import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'

import longTermLeaseFeesRequests from '../LongTermLeaseFees.requests'

const useGetApplicableCurrency = ({
    pricingAccountId,
    customerQuotationId,
}: {
    pricingAccountId: number,
    customerQuotationId: number
}) => {
    return useRequest({
        key: RequestKeys.getLongTermLeaseInvoiceApplicableCurrency,
        params: {
            pricingAccountId,
            customerQuotationId,
        },
        requestFunc: RequestFn.getEntity(longTermLeaseFeesRequests.applicableCurrency,
            async (promise) => {
                const resp: {
                    data,
                } = await promise

                return resp?.data?.items
            }),
        enabled: Boolean(pricingAccountId && customerQuotationId),
    })
}

export default useGetApplicableCurrency
